module.exports = __webpack_public_path__ + "static/img/20160521-MaarsbergenHT_jumbotron.33155be.jpg";